import { Fragment } from 'react';
import Divider from 'src/design/components/divider/Divider';
import FormLabel from 'src/design/components/formLabel/FormLabel';
import FormSelect from 'src/design/components/formSelect/FormSelect';
import InputError from 'src/design/components/inputError/InputError';
import TextInputWithError from 'src/design/components/textInput/TextInputWithError';
import HelpDisclaimer from 'src/design/components/helpDisclaimer/HelpDisclaimer';
import Spacing from 'src/design/styleguide/spacing/Spacing';
import Styledlink from 'src/design/components/hyperlink/Styledlink';
import * as States from 'src/enums/australianStatesAndTerritories';

export const validDriverLicence = ({ licenceNumber = '', licenceCardNumber = '', licenceState = '' }) =>
  /^[A-Za-z0-9]{1,10}$/.test(licenceNumber.trim()) &&
  /^[A-Za-z0-9]{1,10}$/.test(licenceCardNumber.trim()) &&
  licenceState !== 'AUS' && Object.prototype.hasOwnProperty.call(States, licenceState);

const DriverLicenceFields = ({ values, onChange, errors = {}, clearError }) => (
  <Fragment>
    <Divider top="normal" bottom="normal" />
    <FormLabel forId="licence-number">Australian Driver Licence Number</FormLabel>
    <Spacing bottom="normal">
      <TextInputWithError
        forId="licence-number"
        testRef="licence-number-input"
        value={values.licenceNumber || ''}
        placeholder="Enter a valid licence number."
        maxLength={10}
        required
        isCharacterValid={TextInputWithError.validation.alphaNumericOnly}
        onChange={(licenceNumber) => {
          clearError('licence.licenceNumber');
          onChange({ licenceNumber });
        }}
        error={errors['licence.licenceNumber'] && 'Enter a valid licence number.'}
      />
    </Spacing>
    <FormLabel forId="licence-card-number">Driver Licence Card Number</FormLabel>
    <Spacing bottom="normal">
      <div>
        <TextInputWithError
          forId="licence-card-number"
          testRef="licence-card-number-input"
          value={values.licenceCardNumber || ''}
          placeholder="Enter a valid card number."
          maxLength={10}
          required
          isCharacterValid={TextInputWithError.validation.alphaNumericOnly}
          onChange={(licenceCardNumber) => {
            clearError('licence.licenceCardNumber');
            onChange({ licenceCardNumber });
          }}
          error={errors['licence.licenceCardNumber'] && 'Enter a valid card number.'}
        />
        <HelpDisclaimer>This is different from your licence number. Enter the card number shown on your current licence.</HelpDisclaimer>
      </div>
    </Spacing>
    <FormLabel forId="licence-state">State or Territory of Issue</FormLabel>
    <Spacing bottom="normal">
      <div>
        <FormSelect
          forId="licence-state"
          testRef="licence-state-select"
          value={values.licenceState || ''}
          fullWidth
          required
          errorHighlight={!!errors['licence.licenceState']}
          onChange={(licenceState) => {
            clearError('licence.licenceState');
            onChange({ licenceState });
          }}
        >
          <option value="">Please choose state or territory</option>
          {Object.keys(States).filter(state => state !== 'AUS').map(state => <option key={state} value={state}>{States[state]}</option>)}
        </FormSelect>
        {errors['licence.licenceState'] && <InputError error="Please select the state or territory of issue." />}
      </div>
    </Spacing>
    <Spacing bottom="normal">
      <HelpDisclaimer>If you do not have an Australian driver’s licence, email a photo of your passport and proof of address to <Styledlink href="mailto:info@brickx.com">info@brickx.com</Styledlink> so we can verify your identity manually.</HelpDisclaimer>
    </Spacing>
  </Fragment>
);

export default DriverLicenceFields;
